const features = [
    {
        id: 'feature-editor',
        icon: '🔤',
        label: 'AI-Powered Translation Editor',
        headline: 'A Professional-Grade Translation Editor, Powered by AI',
        copy: 'Translate segment-by-segment with smart suggestions, inline glossary highlighting, confidence scores, and real-time spellcheck. Supports RTL languages, inline tags, and formatting preservation.',
        image: '/images/demo6/feature-1.png',
        imageAlt: 'AI-powered translation editor with source and target panes',
    },
    {
        id: 'feature-tm',
        icon: '🧠',
        label: 'Translation Memory & Glossaries',
        headline: 'Never Translate the Same Sentence Twice',
        copy: 'Leverage Translation Memory for automatic fuzzy matching and maintain project-wide glossaries with approval workflows. Ensure consistent terminology across every project.',
        image: '/images/demo6/img-02.png',
        imageAlt: 'Smart suggestions panel showing TM matches and glossary terms',
    },
    {
        id: 'feature-team',
        icon: '👥',
        label: 'Team Collaboration & Role Management',
        headline: 'Built for Translation Teams of Every Size',
        copy: 'Invite translators, reviewers, and managers with granular role-based permissions. Assign tasks, set deadlines, track performance ratings, and manage MT quotas per team member.',
        image: '/images/demo6/img-02.png',
        imageAlt: 'Team management page with member list and permissions',
    },
    {
        id: 'feature-dashboard',
        icon: '📊',
        label: 'Project Dashboard & Analytics',
        headline: 'Complete Visibility into Every Translation Project',
        copy: 'Track active and completed projects, monitor words translated, view language distribution, and export reports. Your personalised dashboard surfaces what matters most.',
        image: '/images/demo6/img-02.png',
        imageAlt: 'Dashboard home with KPI cards and activity chart',
    },
    {
        id: 'feature-files',
        icon: '📁',
        label: 'File Management & Cloud Integrations',
        headline: 'Import from Anywhere. Export in Any Format.',
        copy: 'Upload DOCX, PDF, IDML, PPTX, and XLIFF files or import directly from Google Drive, Dropbox, and OneDrive. Download translated files or export as XLIFF for external CAT tools.',
        image: '/images/demo6/img-02.png',
        imageAlt: 'File manager with cloud integration icons',
    },
    {
        id: 'feature-apps',
        icon: '🔗',
        label: 'Apps Marketplace & Integrations',
        headline: 'Connect Your Entire Workflow',
        copy: 'Integrate with GitHub for developer localization, Slack for notifications, Figma for design-to-translation workflows, and more. Extend Rush Studio with the tools your team already uses.',
        image: '/images/demo6/img-02.png',
        imageAlt: 'Apps marketplace grid with connection status badges',
    },
];

const HeroFeatures = () => {
    return (
        <div className="hero-features-sections">
            {features.map((feature, index) => {
                const isImageLeft = index % 2 === 0;

                return (
                    <div key={feature.id}>
                        <section
                            id={feature.id}
                            className="content-7 wide-60 content-section division"
                        >
                            <div className="container">
                                <div className="row d-flex align-items-center">
                                    {isImageLeft ? (
                                        <>
                                            {/* Image Left */}
                                            <div className="col-md-6 order-last order-md-1">
                                                <div className="content-7-img wow fadeInLeft">
                                                    <img
                                                        className="img-fluid"
                                                        src={feature.image}
                                                        alt={feature.imageAlt}
                                                    />
                                                </div>
                                            </div>
                                            {/* Text Right */}
                                            <div className="col-md-6 order-first order-md-2">
                                                <div className="txt-block right-column wow fadeInRight">
                                                    <span className="section-id txt-upcase">
                                                        {feature.icon} {feature.label}
                                                    </span>
                                                    <h2 className="h2-xs">{feature.headline}</h2>
                                                    <p className="p-lg">{feature.copy}</p>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {/* Text Left */}
                                            <div className="col-md-6 order-last order-md-1">
                                                <div className="txt-block left-column wow fadeInLeft">
                                                    <span className="section-id txt-upcase">
                                                        {feature.icon} {feature.label}
                                                    </span>
                                                    <h2 className="h2-xs">{feature.headline}</h2>
                                                    <p className="p-lg">{feature.copy}</p>
                                                </div>
                                            </div>
                                            {/* Image Right */}
                                            <div className="col-md-6 order-first order-md-2">
                                                <div className="content-7-img wow fadeInRight">
                                                    <img
                                                        className="img-fluid"
                                                        src={feature.image}
                                                        alt={feature.imageAlt}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </section>
                        {index < features.length - 1 && <hr className="divider" />}
                    </div>
                );
            })}
        </div>
    );
};

export default HeroFeatures;
